import Create from "./components/Create";
import './App.css';

function App() {
  return (
    <div className="App">
      <h1 className="app-title">Task manager</h1>
      <Create />
    </div>
  );
}

export default App;
